import { render, staticRenderFns } from "./TkGeneration.vue?vue&type=template&id=01b7ec65&scoped=true&"
import script from "./TkGeneration.vue?vue&type=script&lang=ts&"
export * from "./TkGeneration.vue?vue&type=script&lang=ts&"
import style0 from "./TkGeneration.vue?vue&type=style&index=0&id=01b7ec65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b7ec65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
